<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M17.25,24c-3.722,0-6.75-3.028-6.75-6.75s3.028-6.75,6.75-6.75S24,13.528,24,17.25S20.972,24,17.25,24z M17.25,12
		C14.355,12,12,14.355,12,17.25s2.355,5.25,5.25,5.25s5.25-2.355,5.25-5.25S20.145,12,17.25,12z"/>
	<path d="M19.5,20.25c-0.2,0-0.389-0.078-0.53-0.22l-1.72-1.72l-1.72,1.72c-0.142,0.142-0.33,0.22-0.53,0.22s-0.389-0.078-0.53-0.22
		c-0.292-0.292-0.292-0.768,0-1.061l1.72-1.72l-1.72-1.72c-0.292-0.292-0.292-0.768,0-1.061c0.142-0.142,0.33-0.22,0.53-0.22
		s0.389,0.078,0.53,0.22l1.72,1.72l1.72-1.72c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22
		c0.292,0.292,0.292,0.768,0,1.061l-1.72,1.72l1.72,1.72c0.292,0.292,0.292,0.768,0,1.061C19.889,20.172,19.7,20.25,19.5,20.25z"/>
	<path d="M2.25,16.5C1.009,16.5,0,15.491,0,14.25v-12C0,1.009,1.009,0,2.25,0h16.5C19.991,0,21,1.009,21,2.25v6
		C21,8.664,20.664,9,20.25,9S19.5,8.664,19.5,8.25V6h-18v8.25C1.5,14.664,1.836,15,2.25,15h6C8.664,15,9,15.336,9,15.75
		S8.664,16.5,8.25,16.5H2.25z M19.5,4.5V2.25c0-0.414-0.336-0.75-0.75-0.75H2.25C1.836,1.5,1.5,1.836,1.5,2.25V4.5H19.5z"/>
	<path d="M3.75,9.75C3.336,9.75,3,9.414,3,9s0.336-0.75,0.75-0.75h6c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H3.75z"/>
	<path d="M3.75,12.75C3.336,12.75,3,12.414,3,12s0.336-0.75,0.75-0.75h3c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H3.75z"
		/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'credit-card-remove',
    },
    name: {
      type: String,
      required: false,
      default: 'CreditCardRemove',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>